import React, { useEffect } from "react";
import Header from "@pages/HomeRedesign/components/Header/Header";

/**
 * Sticky Header for AppLayout policy/legacy routes (matches store chrome; no slide-out menu).
 */
export default function RedesignNavChrome() {
  useEffect(() => {
    document.documentElement.setAttribute("data-theme", "dark");
  }, []);

  return <Header />;
}
